import React, { useEffect, useState } from "react";
import { View, Text, ActivityIndicator, StyleSheet } from "react-native";
import { useNavigate } from "react-router-dom";

import global from "../../../../../styles/globalStyles";
import { Header, FooterLinks } from "../../../../common/native";
import { exchangePipedriveToken } from "../../../../../services/api-integrations";

const PipedriveOAuthCallback = () => {
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading",
  );
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const code = searchParams.get("code");

    if (!code) {
      setStatus("error");
      setErrorMessage("Missing authorization code.");
      return;
    }

    const exchangeCode = async () => {
      try {
        await exchangePipedriveToken(code);
        setStatus("success");

        setTimeout(() => {
          navigate("/dashboard");
        }, 1500);
      } catch (err: any) {
        setStatus("error");
        setErrorMessage(err.message);
      }
    };

    exchangeCode();
  }, []);

  return (
    <View style={styles.container}>
      <Header />
      <View style={{ marginTop: 60, alignItems: "center" }}>
        {status === "loading" && (
          <>
            <Text style={global.title}>Authorizing with Pipedrive...</Text>
            <ActivityIndicator size="large" />
          </>
        )}
        {status === "success" && (
          <Text style={[global.title, { color: "green" }]}>
            Authorization successful!
          </Text>
        )}
        {status === "error" && (
          <>
            <Text style={[global.title, { color: "red" }]}>
              Authorization Failed
            </Text>
            <Text style={global.errorText}>{errorMessage}</Text>
          </>
        )}
      </View>
      <FooterLinks />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    alignItems: "center",
    justifyContent: "center",
  },
});

export default PipedriveOAuthCallback;
